
const state = {
  username: '',
  userId: null,
  permissions: {},
  expired: false,
  test: true,
  serverURL: 'https://sinkr.com.br'
}

export default state



// WEBPACK FOOTER //
// ./src/view/login/state/state.js